import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";
import citizenship from "./citizenship";
import citizenshipForm from "./citizenship-form/citizenship-form";

angular
    .module('citizenshipsControl.component', [angularUIB, core, citizenship, citizenshipForm])
    .component('citizenshipsControl', {
        template: require('./citizenships-control.component.html'),
        controller: ['Citizenship', 'notifier', '$uibModal', controller],
        bindings: {

        }
    });

function controller(Citizenship, notifier, $uibModal) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        Citizenship
            .getList({currentPage: $ctrl.currentPage})
            .then(
                function (response) {
                    $ctrl.citizenships = response.data.citizenships;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openForm = function (c) {
        $uibModal
            .open({
                component: 'citizenshipForm',
                resolve: {
                    citizenship: function () {
                        return c;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (!c) {
                        $ctrl.citizenships.push(result);
                    } else {
                        c.code = result.code;
                        c.title = result.title;
                    }
                },
                function () {

                }
            );
    };

    $ctrl.deleteCitizenship = function (c, ind) {
        if (!confirm('Вы действительно хотите удалить эту запись?')) {
            return;
        }
        Citizenship.destroy(c.id).then(
            function () {
                $ctrl.citizenships.splice(ind, 1);
                notifier.successNotify('Параметр успешно удален');
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        )
    };

}

export default 'citizenshipsControl.component';


// WEBPACK FOOTER //
// ./resources/assets/modules/citizenships-control/citizenships-control.component.js